import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLogout } from 'services/hooks';
import { locations } from 'services/routes/locations';

const Logout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const logout = useLogout();

  useEffect(() => {
    logout();

    const redirectPath = searchParams.get('redirect');
    if (redirectPath) {
      window.location.href = redirectPath;
      return;
    }

    navigate(locations.general.discovery.pathname);
  }, [searchParams, logout, navigate]);
  return null;
};

export default Logout;
